/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


import * as Sentry from '@sentry/browser';
import config from './config'


const isProd = process.env.NODE_ENV === 'production';

export const init = () => {
  if (isProd) {
    return Sentry.init({
      dsn: config.sentryDSN,
      environment: config.appEnv,
    });
  }
};

export const handleRouteError = (error: Error, errorInfo?: Record<string, unknown>) => {
  if (!isProd) {
    return console.error(error, errorInfo);
  }

  Sentry.withScope(scope => {
    if (typeof errorInfo === 'object') {
      Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]));
    }
    Sentry.captureException(error);
  });
};

export const loggerMessage = (msg: string, context?: { level?: Sentry.SeverityLevel, [k: string]: unknown }) => {
  if (!isProd) {
    return console.warn(msg, context);
  }

  Sentry.captureMessage(msg, (scope) => {
    if (typeof context === 'object') {
      const { level, ...rest } = context;

      if (level) {
        scope.setLevel(level)
      }

      Object.keys(rest).forEach(key => scope.setExtra(key, context[key]));
    }
    return scope
  })
}
